import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'

import { message, Card, Table, Button, Input, Icon } from 'antd'

import Highlighter from 'react-highlight-words'

import PresetGroupForm from './components/PresetGroupForm'

import { GET_PRESET_GROUP_LIST } from '../../graphql/queries'
import { UPDATE_PRESET_GROUP } from '../../graphql/mutations'

export class PresetGroup extends Component {
  constructor() {
    super()

    this.state = {
      formOpen: false,
      formData: {},
      searchText: ''
    }

    this.openDialog = this.openDialog.bind(this)
    this.onEdit = this.onEdit.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm()
    this.setState({ searchText: selectedKeys[0] })
  }

  handleReset = clearFilters => {
    clearFilters()
    this.setState({ searchText: '' })
  }

  onEdit(params) {
    const { UpdatePresetGroup, data } = this.props

    const self = this

    UpdatePresetGroup({
      variables: params
    })
      .then(result => {
        message.info(
          `PresetGroup "${result.data.updatePresetGroup.name}" update successful`
        )
        data.refetch()
      })
      .then(() => {
        self.setState({
          formOpen: false
        })
      })
      .catch(error => {
        message.error(error.message)
      })
  }

  onClose() {
    this.setState({
      formOpen: false,
      formData: {}
    })
  }

  async openDialog(id) {
    // Set data id
    this.setState({
      formOpen: true,
      formData: {
        id
      }
    })
  }

  render() {
    const { data } = this.props
    const { formOpen, formData } = this.state
    const columns = [
      {
        title: 'Preset Group',
        dataIndex: 'name',
        key: 'name',
        ...this.getColumnSearchProps('name')
      },

      {
        title: 'Action',
        key: 'action',
        width: 100,
        render: (text, record) => (
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={() => {
              this.openDialog(record.id)
            }}
          />
        )
      }
    ]

    return (
      <Card title="Preset Group">
        <Table
          rowKey={record => record.id}
          dataSource={data.presetGroups}
          columns={columns}
        />
        <PresetGroupForm
          visible={formOpen}
          onClose={this.onClose}
          onCreate={this.onCreate}
          onEdit={this.onEdit}
          data={formData}
        />
      </Card>
    )
  }
}

PresetGroup.propTypes = {
  data: PropTypes.object.isRequired,
  UpdatePresetGroup: PropTypes.func.isRequired
}

export default compose(
  graphql(GET_PRESET_GROUP_LIST),
  graphql(UPDATE_PRESET_GROUP, { name: 'UpdatePresetGroup' })
)(PresetGroup)



// WEBPACK FOOTER //
// ./src/pages/PresetGroup/index.js